import { createSelector } from 'reselect';

export const selectDynamicRewardsPageContent = state => state.dynamicRewardsPageContent;

export const selectDynamicRewardsPageContentConfig = createSelector(
  selectDynamicRewardsPageContent,
  dynamicRewardsPageContent => dynamicRewardsPageContent.config,
);

export const selectDynamicRewardsPageContentInfo = createSelector(
  selectDynamicRewardsPageContent,
  dynamicRewardsPageContent => dynamicRewardsPageContent.pageContent,
);

export const selectDynamicRewardsPageContentIsLoading = createSelector(
  selectDynamicRewardsPageContent,
  dynamicRewardsPageContent => dynamicRewardsPageContent.isLoading,
);

export const selectDynamicRewardsPageContentIsLoaded = createSelector(
  selectDynamicRewardsPageContent,
  dynamicRewardsPageContent => dynamicRewardsPageContent.isLoaded,
);
